<template>
  <div class="claim__item" :class="editClass">
    <div v-if="!editing" class="claim__content">
      <h3 class="title--m">{{ getUiString(['claim_details','details','quote','title']) }}</h3>
      <div class="claim--quote">
        <p class="text--small">{{ getUiString(['claim_details','details','quote','body']) }}</p>
        <p>{{ review.quote }}</p>
      </div>
      <button
        @click.prevent="editQuote"
        class="link link--edit"
      >
        <lennoc-icon image="edit" />
        <span>{{ getUiString(['claim_details','details','quote','edit_button']) }}</span>
      </button>
    </div>
    <form-factory
      v-if="editing"
      formclass="claim__content"
      :record="review"
      :schema="schema"
      :hasError="error"
      :submitText="getUiString(['claim_details', 'details', 'quote', 'send_button'])"
      :cancelText="getCancelText"
      @submit="sendMessage"
      @reset="editing = false"
    >
    <h3 class="title--m">{{ getUiString(['claim_details','details','quote','title']) }}</h3>
    <p>{{ getUiString(['claim_details','details','quote','body']) }}</p>
    </form-factory>
    <lennoc-spinner v-if="busy" isFullscreen="false"></lennoc-spinner>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LennocTextArea from '@lennoc/lennoc-components/src/components/LennocTextArea'

export default {
  name: 'CanAddQuote',
  data () {
    return {
      editing: true,
      busy: false,
      review: { id: null, quote: '' },
      error: false
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      claimId: 'claim/claimId',
      getReview: 'claim/getClaimReview'
    }),
    editClass () {
      return this.editing ? 'claim__item--gradient' : ''
    },
    getCancelText () {
      return this.getReview
        ? this.getUiString(['claim_details', 'details', 'quote', 'cancel_button'])
        : ''
    },
    schema () {
      return {
        quote: {
          key: 'quote',
          label: '',
          required: true,
          type: 'String',
          editor: LennocTextArea,
          validators: []
        }
      }
    }
  },
  mounted () {
    this.getCurrentReview()
  },
  methods: {
    editQuote () {
      this.editing = true
    },
    getCurrentReview () {
      const review = this.getReview
      if (review) {
        this.review = { id: review.Id, quote: review.Message }
        this.editing = false
      }
    },
    sendMessage (message) {
      this.busy = true
      this.review = { ...message }
      const data = { claimId: this.claimId, ...this.review }
      this.$store.dispatch('claim/saveReview', data)
        .then(() => { this.$store.dispatch('claim/refreshClaim') })
        .then(() => { this.editing = false })
        .finally(() => { this.busy = false })
    }
  }
}
</script>
